/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PricingRequestFromJSON, PricingRequestToJSON, } from './PricingRequest';
/**
 * Check if a given object implements the CalculatePricingRequestBody interface.
 */
export function instanceOfCalculatePricingRequestBody(value) {
    let isInstance = true;
    isInstance = isInstance && "pricingRequest" in value;
    return isInstance;
}
export function CalculatePricingRequestBodyFromJSON(json) {
    return CalculatePricingRequestBodyFromJSONTyped(json, false);
}
export function CalculatePricingRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pricingRequest': PricingRequestFromJSON(json['pricing_request']),
    };
}
export function CalculatePricingRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pricing_request': PricingRequestToJSON(value.pricingRequest),
    };
}
